import { Navigate, Route, Routes, useNavigate } from "react-router-dom";
import { Suspense, lazy, useEffect, useState } from "react";
import Dashboard from "./Pages/Dashboard/Dashboard";
import NotFound from "./Pages/NotFound/NotFound";
import AddDepartments from "./Pages/AddDepartments/AddDepartments";
import AddDesignation from "./Pages/AddDesignation/AddDesignation";
import AddLocation from "./Pages/AddLocations/AddLocations";
import AddCompany from "./Pages/AddCompany/AddCompany";
import DepartmentAndsubDepartment from "./Pages/Department&subDepartment/DepartmentAndsubDepartment";
import Designation from "./Pages/Designation/Designation";
import Contractors from "./Pages/Contractors/Contractors";
import LeaveTypes from "./Pages/LeaveTypes/LeaveTypes";
import LeaveSettings from "./Pages/LeavesSettings/LeaveSettings";
import ProfileAddStaff from "./Pages/ProfileAddStaff/ProfileAddStaff";
import DepartmentHeads from "./Pages/DepartmentHeads/DepartmentHeads";
import AddShift from "./Pages/AddShift/AddShift";
import SalesDepartment from "./Pages/SalesDepartment/SalesDepartment";
import NewSideBar from "./Pages/NewSideBar/NewSideBar";
import AddAttendanceHead from "./Pages/AttendTeamAdmin/AddAttendanceHead";
import VerifyOtpLogin from "./features/verifyOtpLogin/page";
import { BASE_URL, CHECKAUTH_ENDPOINT, FetchDepartment, FetchDesignation, FetchLocation, FetchShifts, StaffRoleListEndPoint } from "./utils/constant";
import { useDispatch, useSelector } from "react-redux";
import { setUserInformation } from "./store/slices/signUpSlice";
import 'react-toastify/dist/ReactToastify.min.css';
import { ToastContainer } from "react-toastify";
import { setDesig } from "./store/slices/designationSlice";
import { setDept } from "./store/slices/departmentSlice";
import { setShft } from "./store/slices/shiftSlice";
import { setLoc } from "./store/slices/locationSlice";


const Login = lazy(() => import("./features/login/page"));
const ForgotPassword = lazy(() => import("./features/forgotPassword/page"));
const Signup = lazy(() => import("./features/signup/page"));
const VerifyOtp = lazy(() => import("./features/verifyOtp/page"));
const AddCompanyLocation = lazy(() => import("./features/addComapnyLocation/page"));


function App() {
  const authToken = localStorage.getItem("authToken");
  const navigate = useNavigate();
  const userInfo = useSelector((state) => state.signUp.signUpDetails);
  // const [isUserAuth, setIsUserAuth] = useState(authToken ? true :false)
  const [isUserAuth, setIsUserAuth] = useState(authToken || userInfo.authToken ? true :false)
  const dispatch = useDispatch();

  useEffect (() => {

    if (!authToken ) {
      // Redirect to login if authToken is not present
      setIsUserAuth(false)
      navigate('/');
    } else{
      const fetchData = async () => {
        const response = await fetch(`${BASE_URL}/${CHECKAUTH_ENDPOINT}`, {
          method: "GET",
           headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `${authToken }`,
                    
                  },
          body: JSON.stringify(),
        });
        
        if (response.ok) {
          const data = await response.json();
          setIsUserAuth(true)
          localStorage.setItem("authToken", data?.data?.authToken);
          dispatch(setUserInformation(data?.data));

         
        } else {
          const data = await response.json();
          console.log('indexerr',data)
          setIsUserAuth(false)
          localStorage.clear();
          
        }
      };
       fetchData();
    }
	}, [isUserAuth,authToken]);
  
  useEffect(() => {
    console.log('appjs calling')
    if(!authToken  ){
      sessionStorage.clear();
    }
    const departmentData = sessionStorage.getItem('department');
    const designationData = sessionStorage.getItem('designation');
    const shiftData = sessionStorage.getItem('shift');
    const locationData = sessionStorage.getItem('location');
    if(!departmentData){
      getDepartmentList();
    }else{
      dispatch(setDept(JSON.parse(departmentData)))
    }
    
      if(!designationData){   
        getDesignationList();
      }else{
        dispatch(setDesig(JSON.parse(designationData)))
      }
      
      if(!shiftData){   
        getShiftList();
      }else{
        dispatch(setShft(JSON.parse(shiftData)))
      }

        if(!locationData){   
      getLocationList();
        }else{
        dispatch(setLoc(JSON.parse(locationData)))
      }
  }, [authToken]);
  const getDesignationList = async () =>{
    const token = localStorage.getItem('authToken');
  
    try{
        const fetchData = async () => {
          const response = await fetch(`${BASE_URL}/${FetchDesignation}`, {
            method: "POST",
             headers: {
                      'Content-Type': 'application/json',
                      'Authorization': `${token}`,
                      
                    },
            body: JSON.stringify({isDeleted:false}),
          });
          
          if (response.ok) {
            const data = await response.json();
            const activeDesignation = data.data.filter(item => item.isActive);
            console.log('activeDesignation',activeDesignation)
            const newArray = activeDesignation.map((item) => ({
                value: item.designationName,
                key: item.designationId
              }));
              sessionStorage.setItem('designation', JSON.stringify(newArray));
              dispatch(setDesig(newArray));

          
          } else {
            const data = await response.json();
            console.log('departmenterr',data)
           
            
          }
        };
        await fetchData();
      } catch (error) {
        console.error('Error updating designation:', error);
    }
  }
  const getDepartmentList = async () =>{
    const token = localStorage.getItem('authToken');
  
    try{
        const fetchData = async () => {
          const response = await fetch(`${BASE_URL}/${FetchDepartment}`, {
            method: "POST",
             headers: {
                      'Content-Type': 'application/json',
                      'Authorization': `${token}`,
                      
                    },
            body: JSON.stringify({isDeleted:false}),
          });
          
          if (response.ok) {
            const data = await response.json();
            const activeDepartment = data.data.filter(item => item.isActive);
            console.log('activeDepartment',activeDepartment)
            const newArray = activeDepartment.map((item) => ({
                value: item.departmentName,
                key: item.departmentId
              }));
              sessionStorage.setItem('department', JSON.stringify(newArray));
              dispatch(setDept(newArray));
          } else {
            const data = await response.json();
            console.log('departmenterr',data)
           
            
          }
        };
        await fetchData();
      } catch (error) {
        console.error('Error updating designation:', error);
    }
  }
  const getShiftList = async () =>{
    const token = localStorage.getItem('authToken');
  
    try{
        const fetchData = async () => {
          const response = await fetch(`${BASE_URL}/${FetchShifts}`, {
            method: "POST",
             headers: {
                      'Content-Type': 'application/json',
                      'Authorization': `${token}`,
                      
                    },
            body: JSON.stringify({}),
          });
          
          if (response.ok) {
            const data = await response.json();
            const activeShift = data.data.filter(item => item.isActive);
            console.log('activeShift',activeShift)
            const newArray = activeShift.map((item) => ({
                value: item.shiftFullName,
                key: item.shiftId
              }));
              
              sessionStorage.setItem('shift', JSON.stringify(newArray));
              dispatch(setShft(newArray));
          
          } else {
            const data = await response.json();
            console.log('shifterr',data)
           
            
          }
        };
        await fetchData();
      } catch (error) {
        console.error('Error updating designation:', error);
    }
  }
  const getLocationList = async () =>{
    const token = localStorage.getItem('authToken');
  
    try{
        const fetchData = async () => {
          const response = await fetch(`${BASE_URL}/${FetchLocation}`, {
            method: "POST",
             headers: {
                      'Content-Type': 'application/json',
                      'Authorization': `${token}`,
                      
                    },
            body: JSON.stringify({isDeleted:false}),
          });
          
          if (response.ok) {
            const data = await response.json();
            const activeLocation = data.data.filter(item => item.isActive);
            console.log('activeLocation',activeLocation)
            const newArray = activeLocation.map((item) => ({
                value: item.locationName1,
                key: item.locationId
              }));
              sessionStorage.setItem('location', JSON.stringify(newArray));
              dispatch(setLoc(newArray));          
          } else {
            const data = await response.json();
            console.log('locationerr',data)
           
            
          }
        };
        await fetchData();
      } catch (error) {
        console.error('Error updating designation:', error);
    }
  }
  return (
    <Suspense fallback={<div>Loading...</div>}>
          <ToastContainer position="top-right" autoClose={2000} />

      <Routes>
          <>
          {authToken || userInfo.authToken ?  <Route exact path='/dashboard'  element={<Dashboard />}/> : ''}
      {isUserAuth && <Route path="/" element={<Navigate to="/dashboard" />} />}
        {!isUserAuth && (
            <>
        <Route exact path='/dashboard'  element={<Navigate to="/" />} />
        <Route exact path="/" element={<Login />} />
        <Route exact path="/forgotpassword" element={<ForgotPassword />} />
        <Route exact path="/signup" element={<Signup />} />
        <Route exact path="/verifyotp" element={<VerifyOtp />} />
        <Route exact path="/verifyotpLogin" element={<VerifyOtpLogin />} />
        </>
        )}
      {userInfo?.userRole == "businessOwner" && (
        <>
           <Route
          exact
          path="/addcompanylocation"
          element={<AddCompanyLocation />}
          />
        <Route
          exact
          path="/departmentandsubdepartment"
          element={<DepartmentAndsubDepartment />}
          />
        <Route exact path="/designation" element={<Designation />} />
        <Route exact path="/addshift" element={<AddShift />} />
        <Route path="/profileaddstaff" element={<ProfileAddStaff />} />
        </>
         )}
        <Route exact path="/dashboard/*" element={<Dashboard />} />
        {/* <Route exact path="/addcompany" element={<AddCompany />} /> */}
        {/* <Route exact path="/contractor" element={<Contractors />} /> */}
        {/* <Route exact path="/leavetypes" element={<LeaveTypes />} />
        <Route exact path="/leavesettings" element={<LeaveSettings />} /> */}
        

        {/* <Route path="/profileaddstaff" element={<Navigate to="/" />} /> */}
      
        {/* <Route exact path="/profileaddstaff" element={<ProfileAddStaff />} /> */}
        {/* <Route exact path="/departmentheads" element={<DepartmentHeads />} /> */}
        {/* <Route exact path="/adddepartments" element={<AddDepartments />} />
        <Route exact path="/adddesignation" element={<AddDesignation />} />
        <Route exact path="/addlocation" element={<AddLocation />} /> */}
        {/* <Route exact path="/dashboard/addAttendHead" element={<AddAttendanceHead />} /> */}
        {/* <Route exact path="/newsidebar" element={<NewSideBar />} /> */}
        {/* {isUserAuth && <Route exact path="/salesdepartment/:id" element={<SalesDepartment />} />} */}

        <Route path="/*" element={<NotFound />} />
        </>

      </Routes>
    </Suspense>
  );
}

export default App;
